import React, { FC, useState, useMemo } from 'react';
import { Button } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { ContentFilter } from '@wix/wix-ui-icons-common';
import { useExploreContext } from '@components/Contexts/ExploreContext';
import { activeFilterCount } from '@utils/filterUtils';
import MobileFilterMenu from '../MobileFilterMenu';

const MobileFilterButton: FC = () => {
  const {
    state: {
      selectedServices,
      selectedLanguages,
      selectedPricing,
      selectedLocation,
    },
  } = useExploreContext();
  const { t } = useTranslation();

  const [openMobileFilter, setOpenMobileFilter] = useState(false);

  const numActiveFilters = useMemo(() => {
    return activeFilterCount({
      selectedServices,
      selectedLanguages,
      selectedPricing,
      selectedLocation,
    });
  }, [selectedServices, selectedLanguages, selectedPricing, selectedLocation]);

  return (
    <>
      <Button
        dataHook="mobile-filter-button"
        priority="secondary"
        prefixIcon={<ContentFilter />}
        onClick={() => setOpenMobileFilter(true)}
      >
        {numActiveFilters > 0
          ? t('mobile-filter-button-cta', { number: numActiveFilters })
          : t('mobile-filter-button-cta-no-number')}
      </Button>
      {openMobileFilter && (
        <MobileFilterMenu setOpenMobileFilter={setOpenMobileFilter} />
      )}
    </>
  );
};

export default MobileFilterButton;
